import React, { useEffect, useState } from "react";
import QuizTaker from "./_components/quiz-taker";
import { BaseUrlApi, ErrorMessage } from "../../../lib/api";
import { toast } from "sonner";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { QuizData } from "../../../lib/languages";
import { useLanguage } from "../../../context/LanguageContext";
import { Loader2 } from "lucide-react";

export default function UserQuizExam() {
  const { language } = useLanguage();
  const t = QuizData[language] || QuizData.en;

  const [questions, setQuestions] = useState([]);
  const { state } = useLocation();
  const quiz = state?.quiz;
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  const ApiUrl =
    quiz?.has_attempted && quiz?.show_answer
      ? `student/answer-quizzes/${quiz?.id}`
      : `quizzes/${quiz?.bid}`;

  const getAllQuestions = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/${ApiUrl}`);
      setQuestions(data.data?.questions);
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingQuestions(false);
    }
  };

  useEffect(() => {
    setLoadingQuestions(true);
    getAllQuestions();
  }, []);

  if (quiz?.has_attempted && !quiz?.show_answer) {
    return <Navigate to={-1} replace={true} />;
  }

  if (loadingQuestions)
    return (
      <div className="flex flex-col gap-2 items-center justify-center h-[80%] text-xl">
        <Loader2 className="w-7 h-7 animate-spin" />
        {t.loading}
      </div>
    );

  return (
    <QuizTaker questions={questions} setQuestions={setQuestions} quiz={quiz} />
  );
}
